import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { serverUrl } from "src/environments/environment";
import { RoleDto } from '../dto/Role-dto';

import { CompanyDto } from '../dto/Company-dto';
import { EmployeeDto } from '../dto/Employee-dto';
import { StatesDto } from '../dto/States-dto';
import { PaymentDto } from '../dto/Payment-dto';
import { CategoryDetailsDto } from '../dto/Category-Details-dto';
import { ShopDto } from '../dto/Shop-dto';
import { CompanyPolicyDto } from '../dto/Company-Policy-dto';
import { StaffDto } from '../dto/Staff-dto';
import { DesignDetailsDto } from '../dto/Design-Details-dto';
import { ApplicationModuleDto } from '../dto/Application-dto';
import { OrderDto } from '../dto/Order-dto';
import { CompanyAboutUsDto } from '../dto/Company-AboutUs-dto';
import { UnitDetailsDto } from '../dto/Unit-Details-dto';
import { BannerImgDetailsDto } from '../dto/Banner-Img-Details-dto';
import { PartyDto } from '../dto/Party-dto';
import { BillingDto } from '../dto/Billing-dto';
import { ColorsDto } from '../dto/Colors-dto';
import { CustomerDto } from '../dto/Customer-dto';



@Injectable({
    providedIn: 'root'
})
export class MasterService {


    private _baseUrl = serverUrl.webMaster;

    constructor(
        private http: HttpClient,
    ) {
    }




    //Shop



    createCompanyData(companyDto: Object): Observable<CompanyDto> {
        return this.http.post<CompanyDto>(`${this._baseUrl}/createCompanyData`, companyDto);
    }

    getCompany(companyDto: Object): Observable<CompanyDto[]> {
        return this.http.post<CompanyDto[]>(`${this._baseUrl}/getCompany`, companyDto);
    }

    uploadCompanyLogo(formData: Object): Observable<FormData> {
        return this.http.post<FormData>(`${this._baseUrl}/uploadCompanyLogo`, formData);
    }

    createShopData(shopDto: Object): Observable<ShopDto> {
        return this.http.post<ShopDto>(`${this._baseUrl}/createShopData`, shopDto);
    }

    getShop(shopDto: Object): Observable<ShopDto[]> {
        return this.http.post<ShopDto[]>(`${this._baseUrl}/getShop`, shopDto);
    }

    uploadShopLogo(formData: Object): Observable<FormData> {
        return this.http.post<FormData>(`${this._baseUrl}/uploadShopLogo`, formData);
    }

    createCompanyPolicy(companyPolicyDto: Object): Observable<CompanyPolicyDto> {
        return this.http.post<CompanyPolicyDto>(`${this._baseUrl}/createCompanyPolicy`, companyPolicyDto);
    }

    getCompanyPolicy(companyPolicyDto: Object): Observable<CompanyPolicyDto[]> {
        return this.http.post<CompanyPolicyDto[]>(`${this._baseUrl}/getCompanyPolicy`, companyPolicyDto);
    }

    getRole(roleDto: Object): Observable<RoleDto[]> {
        return this.http.post<RoleDto[]>(`${this._baseUrl}/getRoleDtls`, roleDto);
    }

    createStaffData(staffDto: Object): Observable<StaffDto> {
        return this.http.post<StaffDto>(`${this._baseUrl}/createStaffData`, staffDto);
    }

    getStaff(staffDto: Object): Observable<StaffDto[]> {
        return this.http.post<StaffDto[]>(`${this._baseUrl}/getStaff`, staffDto);
    }

    getCategoryType(categoryDetailsDtoSave: Object): Observable<CategoryDetailsDto[]> {
        return this.http.post<CategoryDetailsDto[]>(`${this._baseUrl}/getCategoryType`, categoryDetailsDtoSave);
    }

    getCategoryName(categoryDetailsDtoSave: Object): Observable<CategoryDetailsDto[]> {
        return this.http.post<CategoryDetailsDto[]>(`${this._baseUrl}/getCategoryName`, categoryDetailsDtoSave);
    }

    getSubCategory(categoryDetailsDtoSave: Object): Observable<CategoryDetailsDto[]> {
        return this.http.post<CategoryDetailsDto[]>(`${this._baseUrl}/getSubCategory`, categoryDetailsDtoSave);
    }

    uploadDesignLogo(formData: Object): Observable<FormData> {
        return this.http.post<FormData>(`${this._baseUrl}/uploadDesignLogo`, formData);
    }




    getOrderAssigningData(orderDto: Object): Observable<OrderDto[]> {
        return this.http.post<OrderDto[]>(`${this._baseUrl}/getOrderAssigningData`, orderDto);
    }
    getStates(statesDto: Object): Observable<StatesDto[]> {
        return this.http.post<StatesDto[]>(`${this._baseUrl}/getStates`, statesDto);
    }

    getMeasurementHeadsDtls(categoryDetailsDtoSave: Object): Observable<CategoryDetailsDto[]> {
        return this.http.post<CategoryDetailsDto[]>(`${this._baseUrl}/getMeasurementHeadsDtls`, categoryDetailsDtoSave);
    }

    getMeasurementDetData(orderDto: Object): Observable<OrderDto[]> {
        return this.http.post<OrderDto[]>(`${this._baseUrl}/getMeasurementDetData`, orderDto);
    }

    updateOrderDetails(orderDto: Object): Observable<OrderDto> {
        return this.http.post<OrderDto>(`${this._baseUrl}/updateOrderDetails`, orderDto);
    }
    getOrderStatus(orderDto: Object): Observable<OrderDto[]> {
        return this.http.post<OrderDto[]>(`${this._baseUrl}/getOrderStatus`, orderDto);
    }

    getNewOrderDetails(orderDto: Object): Observable<OrderDto> {
        return this.http.post<OrderDto>(`${this._baseUrl}/getNewOrderDetails`, orderDto);
    }

    getPendingOrderDetails(orderDto: Object): Observable<OrderDto> {
        return this.http.post<OrderDto>(`${this._baseUrl}/getPendingOrderDetails`, orderDto);
    }

    getOnGoingOrderDetails(orderDto: Object): Observable<OrderDto> {
        return this.http.post<OrderDto>(`${this._baseUrl}/getOnGoingOrderDetails`, orderDto);
    }

    getExpiredOrderDetails(orderDto: Object): Observable<OrderDto> {
        return this.http.post<OrderDto>(`${this._baseUrl}/getExpiredOrderDetails`, orderDto);
    }

    getUpcomingOrderDetails(orderDto: Object): Observable<OrderDto> {
        return this.http.post<OrderDto>(`${this._baseUrl}/getUpcomingOrderDetails`, orderDto);
    }

    getQcFailedOrderDetails(orderDto: Object): Observable<OrderDto> {
        return this.http.post<OrderDto>(`${this._baseUrl}/getQcFailedOrderDetails`, orderDto);
    }

    getStaffDetails(staffDto: Object): Observable<StaffDto[]> {
        return this.http.post<StaffDto[]>(`${this._baseUrl}/getStaffDetails`, staffDto);
    }

    saveMasterImageDet(orderDto: Object): Observable<OrderDto> {
        return this.http.post<OrderDto>(`${this._baseUrl}/saveMasterImageDet`, orderDto);
    }

    getMasterImagegData(orderDto: Object): Observable<OrderDto[]> {
        return this.http.post<OrderDto[]>(`${this._baseUrl}/getMasterImagegData`, orderDto);
    }

    //Starts foologics Admin Console Panel Added on 25/10/2023 by Abubakkar
    createCompanyAboutUs(companyAboutUsDto: Object): Observable<CompanyAboutUsDto> {
        return this.http.post<CompanyAboutUsDto>(`${this._baseUrl}/createCompanyAboutUs`, companyAboutUsDto);
    }
    getCompanyAboutUs(companyAboutUsDto: Object): Observable<CompanyAboutUsDto[]> {
        return this.http.post<CompanyAboutUsDto[]>(`${this._baseUrl}/getCompanyAboutUs`, companyAboutUsDto);
    }
    createHomeBannerImages(companyAboutUsDto: Object): Observable<CompanyAboutUsDto[]> {
        return this.http.post<CompanyAboutUsDto[]>(`${this._baseUrl}/createHomeBannerImages`, companyAboutUsDto);
    }
    createCategoryDtls(categoryDetailsDtoSave: Object): Observable<CategoryDetailsDto> {
        return this.http.post<CategoryDetailsDto>(`${this._baseUrl}/createCategoryDtls`, categoryDetailsDtoSave);
    }

    getCategoryDtls(categoryDetailsDtoSave: Object): Observable<CategoryDetailsDto[]> {
        return this.http.post<CategoryDetailsDto[]>(`${this._baseUrl}/getCategoryDtls`, categoryDetailsDtoSave);
    }

    uploadProductCategoryImg(formData: Object): Observable<FormData[]> {
        return this.http.post<FormData[]>(`${this._baseUrl}/uploadProductCategoryImg`, formData);
    }
    //	Added by abubakar on 27/10/2023
    getUnitDetails(unitDetailsDtoSave: Object): Observable<UnitDetailsDto[]> {
        return this.http.post<UnitDetailsDto[]>(`${this._baseUrl}/getUnitDetails`, unitDetailsDtoSave);
    }

    createDesignData(designDetailsDto: Object): Observable<DesignDetailsDto> {
        return this.http.post<DesignDetailsDto>(`${this._baseUrl}/createDesignData`, designDetailsDto);
    }

    getDesignData(designDetailsDto: Object): Observable<DesignDetailsDto[]> {
        return this.http.post<DesignDetailsDto[]>(`${this._baseUrl}/getDesignData`, designDetailsDto);
    }

    createUnitDetails(unitDetailsDto: Object): Observable<UnitDetailsDto> {
        return this.http.post<UnitDetailsDto>(`${this._baseUrl}/createUnitDetails`, unitDetailsDto);
    }

    getColours(designDetailsDto: Object): Observable<DesignDetailsDto[]> {
        return this.http.post<DesignDetailsDto[]>(`${this._baseUrl}/getColours`, designDetailsDto);
    }
    // uploadProductMultipleImg(formData: Object): Observable<FormData[]> {
    //     return this.http.post<FormData[]>(`${this._baseUrl}/uploadProductMultipleImg`, formData);
    // }
    uploadProductMultipleImg(
        formData: FormData
    ): Observable<any> {

        return this.http.post<any>(
            `${this._baseUrl}/uploadProductMultipleImg`,
            formData
        );
    }
    //31/10/2023 added by abubakkar
    createProductMultipImg(designDetailsDto: Object): Observable<DesignDetailsDto[]> {
        return this.http.post<DesignDetailsDto[]>(`${this._baseUrl}/createProductMultipImg`, designDetailsDto);
    }
    getPlacedOrderDetails(orderDto: Object): Observable<OrderDto> {
        return this.http.post<OrderDto>(`${this._baseUrl}/getPlacedOrderDetails`, orderDto);
    }

    getBannerImg(designDetailsDto: Object): Observable<BannerImgDetailsDto[]> {
        return this.http.post<BannerImgDetailsDto[]>(`${this._baseUrl}/getBannerImg`, designDetailsDto);
    }

    //added by abubakkar on 01/11/2023
    getUpcomingDeliveryDetails(orderDto: Object): Observable<OrderDto[]> {
        return this.http.post<OrderDto[]>(
            `${this._baseUrl}/getUpcomingDeliveryDetails`,
            orderDto
        );
    }
    getWeeklyOrdersDashboard(orderDto: Object): Observable<OrderDto[]> {
        return this.http.post<OrderDto[]>(`${this._baseUrl}/getWeeklyOrdersDashboard`, orderDto);
    }

    getMonthlyCategoryOrdersDashboard(orderDto: Object): Observable<OrderDto[]> {
        return this.http.post<OrderDto[]>(`${this._baseUrl}/getMonthlyCategoryOrdersDashboard`, orderDto);
    }

    getMyOrders(orderDto: Object): Observable<OrderDto[]> {
        return this.http.post<OrderDto[]>(`${this._baseUrl}/getMyOrders`, orderDto);
    }
    //Added by abubakkar on 03/11/2023

    getCustomerDetails(shopDto: Object): Observable<ShopDto[]> {
        return this.http.post<ShopDto[]>(`${this._baseUrl}/getCustomerDetails`, shopDto);
    }
    getOnGoingOrderDetails_v2(orderDto: Object): Observable<OrderDto[]> {
        return this.http.post<OrderDto[]>(`${this._baseUrl}/getOnGoingOrderDetails_v2`, orderDto);
    }

    updateOrderTrackingDetailsDetails(orderDto: Object): Observable<OrderDto> {
        return this.http.post<OrderDto>(`${this._baseUrl}/updateOrderTrackingDetailsDetails`, orderDto);
    }

    //Added by abubakkar on 07/11/2023

    deleteProductCategory(categoryDetailsDto: Object): Observable<CategoryDetailsDto> {
        return this.http.post<CategoryDetailsDto>(`${this._baseUrl}/deleteProductCategory`, categoryDetailsDto);
    }

    deleteProduct(designDetailsDto: Object): Observable<DesignDetailsDto> {
        return this.http.post<DesignDetailsDto>(`${this._baseUrl}/deleteProduct`, designDetailsDto);
    }

    removeAllProductImages(designDetailsDto: Object): Observable<DesignDetailsDto> {
        return this.http.post<DesignDetailsDto>(`${this._baseUrl}/removeAllProductImages`, designDetailsDto);
    }

    removeBannerImg(designDetailsDto: Object): Observable<DesignDetailsDto> {
        return this.http.post<DesignDetailsDto>(`${this._baseUrl}/removeBannerImg`, designDetailsDto);
    }

    removeAllBannerImages(designDetailsDto: Object): Observable<DesignDetailsDto> {
        return this.http.post<DesignDetailsDto>(`${this._baseUrl}/removeAllBannerImages`, designDetailsDto);
    }
    getOnClickedCurrentMonthWiseDetails(orderDto: Object): Observable<OrderDto[]> {
        return this.http.post<OrderDto[]>(`${this._baseUrl}/getOnClickedCurrentMonthWiseDetails`, orderDto);
    }
    getOnClickedOverAllOrderDetails(orderDto: Object): Observable<OrderDto[]> {
        return this.http.post<OrderDto[]>(`${this._baseUrl}/getOnClickedOverAllOrderDetails`, orderDto);
    }
    saveSupplierDetails(partyDto: Object): Observable<PartyDto> {
        return this.http.post<PartyDto>(
            `${this._baseUrl}/saveSupplierDetailsApi`,
            partyDto
        );
    }
    deleteSupplierDetails(partyDto: Object): Observable<PartyDto> {
        return this.http.post<PartyDto>(
            `${this._baseUrl}/deleteSupplierDetailsApi`,
            partyDto
        );
    }
    getSupplierDetailsTable(partyDto: Object): Observable<PartyDto[]> {
        return this.http.post<PartyDto[]>(
            `${this._baseUrl}/getSupplierDetailsTableApi`,
            partyDto
        );
    }


    saveInwardEntryDetails(billingDto: Object): Observable<BillingDto> {
        return this.http.post<BillingDto>(
            `${this._baseUrl}/saveInwardEntryDetailsApi`,
            billingDto
        );
    }
    getItemDetailsTable(partyDto: Object): Observable<PartyDto[]> {
        return this.http.post<PartyDto[]>(
            `${this._baseUrl}/getItemDetailsTableApi`,
            partyDto
        );
    }
    getColorMasters(colorsDto: Object): Observable<ColorsDto[]> {
        return this.http.post<ColorsDto[]>(
            `${this._baseUrl}/getColorMasters`,
            colorsDto
        );
    }
    getItemDetails(billingDto: Object): Observable<BillingDto[]> {
        return this.http.post<BillingDto[]>(
            `${this._baseUrl}/getItemDetailsApi`,
            billingDto
        );
    }
    getInwardDetailsReport(billingDto: Object): Observable<BillingDto[]> {
        return this.http.post<BillingDto[]>(
            `${this._baseUrl}/getInwardDetailsReportApi`,
            billingDto
        );
    }
    deleteWholeInwardDetails(billingDto: Object): Observable<PartyDto> {
        return this.http.post<PartyDto>(
            `${this._baseUrl}/deleteWholeInwardDetailsApi`,
            billingDto
        );
    }
    saveEditRequestForInwardEntry(billingDto: Object): Observable<BillingDto> {
        return this.http.post<BillingDto>(
            `${this._baseUrl}/saveEditRequestForInwardEntry`,
            billingDto
        );
    }
    //
    getPODetailsReport(billingDto: Object): Observable<BillingDto[]> {
        return this.http.post<BillingDto[]>(
            `${this._baseUrl}/getPODetailsReportApi`,
            billingDto
        );
    }
    getCustomerDetailsTable(customerDto: Object): Observable<CustomerDto[]> {
        return this.http.post<CustomerDto[]>(
            `${this._baseUrl}/getCustomerDetailsTable`,
            customerDto
        );
    }
    getInwardSummaryReport(billingDto: Object): Observable<BillingDto[]> {
        return this.http.post<BillingDto[]>(
            `${this._baseUrl}/getInwardSummaryReportApi`,
            billingDto
        );
    }
    getLiveStockSectionWiseDetails(billingDto: Object): Observable<BillingDto[]> {
        return this.http.post<BillingDto[]>(
            `${this._baseUrl}/getLiveStockSectionWiseDetailsApi`,
            billingDto
        );
    }
    getLiveStockDetails(billingDto: Object): Observable<BillingDto[]> {
        return this.http.post<BillingDto[]>(
            `${this._baseUrl}/getLiveStockDetailsApi`,
            billingDto
        );
    }
    //
    getInvoiceDetailsReport(billingDto: Object): Observable<BillingDto[]> {
        return this.http.post<BillingDto[]>(
            `${this._baseUrl}/getInvoiceDetailsReport`,
            billingDto
        );
    }
    getInvoiceDetailSummary(billingDto: Object): Observable<BillingDto[]> {
        return this.http.post<BillingDto[]>(
            `${this._baseUrl}/getInvoiceDetailSummaryApi`,
            billingDto
        );
    }
    getInvoiceSummaryReport(billingDto: Object): Observable<BillingDto[]> {
        return this.http.post<BillingDto[]>(
            `${this._baseUrl}/getInvoiceSummaryReportApi`,
            billingDto
        );
    }

    getOrderSummaryReport(billingDto: Object): Observable<BillingDto[]> {
        return this.http.post<BillingDto[]>(
            `${this._baseUrl}/getOrderSummaryReportApi`,
            billingDto
        );
    }
    getInvoiceDetailSummaryForPrint(billingDto: Object): Observable<BillingDto> {
        return this.http.post<BillingDto>(
            `${this._baseUrl}/getInvoiceDetailSummaryForPrint`,
            billingDto
        );
    }
    getCustomerCategory(customerDto: Object): Observable<CustomerDto[]> {
        return this.http.post<CustomerDto[]>(`${this._baseUrl}/getCustomerCategory`, customerDto);
    }

    getMonthlyOrderWithCustomerCategory(orderDto: Object): Observable<OrderDto[]> {
        return this.http.post<OrderDto[]>(`${this._baseUrl}/getMonthlyOrderWithCustomerCategoryApi`, orderDto);
    }

    getWeeklyOrderWithCustomerCategory(orderDto: Object): Observable<OrderDto[]> {
        return this.http.post<OrderDto[]>(`${this._baseUrl}/getWeeklyOrderWithCustomerCategoryApi`, orderDto);
    }


    createFootComplintsDtls(categoryDetailsDtoSave: Object): Observable<CategoryDetailsDto> {
        return this.http.post<CategoryDetailsDto>(`${this._baseUrl}/createFootComplintsDtls`, categoryDetailsDtoSave);
    }

    // getFootComplaintsTypesDtls(categoryDetailsDto: Object): Observable<CategoryDetailsDto[]> {
    //     return this.http.post<CategoryDetailsDto[]>(`${ this._baseUrl } / getFootComplaintsTypesDtlsApi`, categoryDetailsDto);
    // }

    uploadFootComplaintsImg(formData: Object): Observable<FormData[]> {
        return this.http.post<FormData[]>(`${this._baseUrl}/uploadFootComplaintsImg`, formData);
    }

    deleteFootComplaints(categoryDetailsDto: Object): Observable<CategoryDetailsDto> {
        return this.http.post<CategoryDetailsDto>(`${this._baseUrl}/deleteFootComplaints`, categoryDetailsDto);
    }

    getFootComplaintsTypesDetails(categoryDetailsDto: Object): Observable<CategoryDetailsDto[]> {
        return this.http.post<CategoryDetailsDto[]>(`${this._baseUrl}/getFootComplaintsTypesDetails`, categoryDetailsDto);
    }

}